import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

class SwiperSliders {
    constructor() {

        var gulliverThumbs = new Swiper(".gulliverThumbs", {
            spaceBetween: 0,
            loop: true,
            slidesPerView: 'auto',
            allowTouchMove: false,
            initialSlide: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            // breakpoints: {
            //     1024: {
            //         spaceBetween: 5,
            //     },
            // }
        });

        var sliderGulliver = new Swiper(".gulliverMain", {
            spaceBetween: 30,
            effect: "fade",
            loop: true,
            crossFade: true,
            loop: true,
            autoplay: {
                delay: 12000,
            },
            speed: 700,
            allowTouchMove: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        sliderGulliver.on('slideNextTransitionStart', function () {
            gulliverThumbs.slideNext(700, true);
        });
        sliderGulliver.on('slidePrevTransitionStart', function () {
            gulliverThumbs.slidePrev(700, true);
        });
        sliderGulliver.on('navigationNext', function () {
            sliderGulliver.autoplay.stop();
        });
        sliderGulliver.on('navigationPrev', function () {
            sliderGulliver.autoplay.stop();
        });
        
        var SliderPagination = new Swiper('.slider-pagination__slider', {
            loop: true,
            allowTouchMove: true,
            autoplay: {
                delay: 6000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: false,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            breakpoints: {
                1024: {
                    navigation: {
                        enabled: true,
                    },
                    allowTouchMove: false,
                },
            },
        });

        var SliderOnas = new Swiper('.slider-onas__slider', {
            loop: true,
            autoplay: {
                delay: 5000,
            },
            effect: 'fade',
            crossFade: true,
        });

        var OnasGalleryThumbs = new Swiper(".about-gallery-thumbs", {
            spaceBetween: 9,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                400: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 9,
                },
            },
        });

        var OnasGallery = new Swiper(".about-gallery", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: OnasGalleryThumbs,
            },
            keyboard: {
                enabled: true,
            },
            on: {
                init: function () {
                    var staticSlides = document.querySelectorAll('.giveaways__gallery-image');
                    staticSlides.forEach(element => {
                        let slideIndex = element.getAttribute('data-index');
                        element.addEventListener('click', () => {
                            OnasGallery.slideTo(slideIndex, 300, false);
                        })
                    });
                }
            }
        });
    }
}
export default SwiperSliders;

